import { render, staticRenderFns } from "./FilialOrdersPage.vue?vue&type=template&id=2c6b8cd7&scoped=true&"
import script from "./FilialOrdersPage.vue?vue&type=script&lang=js&"
export * from "./FilialOrdersPage.vue?vue&type=script&lang=js&"
import style0 from "./FilialOrdersPage.vue?vue&type=style&index=0&id=2c6b8cd7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6b8cd7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
